import { Import, Pin, Delete } from '../../icons';
import ConfirmModal from '../../confirmationmodal/confirmationModal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeleteNoteAttachment } from '../../../hooks/useDeleteNoteAttachment';
import { downloadBase64File, formatFileSize } from '../../../constants/utilityFunctions';
import { INote } from '../../../interface/notes';
import { EmailFileWrapper } from '../../../assets/styles/components/dashboard.styled';
import { Flex } from 'antd';
import { DefaultIconButton, Tooltip } from '../../Ant';

interface NoteAttachmentProps {
  note: INote;
  detailedView?: boolean;
  refetch?: () => void;
}

const NoteAttachment = ({ note, detailedView = false, refetch }: NoteAttachmentProps) => {
  const { t } = useTranslation();
  const deleteNoteMutation = useDeleteNoteAttachment();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState<boolean>(false);
  const deleteNote = () => {
    deleteNoteMutation.mutate(note?.id, {
      onSettled() {
        setShowDeleteConfirm(false);
        refetch?.();
      },
    });
  };
  const downloadNoteAttachment = () => {
    downloadBase64File(
      note?.attachmentFileData,
      note?.attachmentFileName,
      note?.attachmentMimeType,
    );
  };
  return (
    <>
      <EmailFileWrapper vertical className={`${detailedView ? 'w-full' : ''}`}>
        <Flex gap={5} align="center" className="email-file-name">
          <Pin />
          <p>{note?.attachmentFileName ?? ''}</p>
        </Flex>
        {detailedView && (
          <div className="d-flex justify-between items-center email-more-info">
            <p>{formatFileSize(note?.attachmentFileSize ?? 0)}</p>
            <Flex gap={5}>
              <Tooltip title={t('note:delete')} placement="top" arrow={false}>
                <DefaultIconButton
                  aria-label={t('note:delete')}
                  type="text"
                  icon={<Delete />}
                  className="attachment-cta"
                  onClick={() => setShowDeleteConfirm(true)}
                />
              </Tooltip>
              <Tooltip title={t('note:download')} placement="top" arrow={false}>
                <DefaultIconButton
                  aria-label={t('note:download')}
                  type="text"
                  icon={<Import />}
                  onClick={downloadNoteAttachment}
                  className="attachment-cta"
                />
              </Tooltip>
            </Flex>
          </div>
        )}
      </EmailFileWrapper>
      <ConfirmModal
        visible={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
        icon={<Delete />}
        title={t('note:deleteNoteAttachmentQuestion')}
        subtitle={t('note:deleteNoteText')}
        cancelText={t('common:cancel')}
        confirmText={t('note:delete')}
        onConfirm={deleteNote}
      />
    </>
  );
};

export default NoteAttachment;
